import { Snackbar, Alert } from "@mui/material";
import { useState } from "react";

export type ToastProps = {
    message: string;
    isError: boolean;
    onClose: () => void;
};

export const Toast = (props: ToastProps) => {
    const [open, setOpen] = useState(true);

    const handleClose = (
        _event?: React.SyntheticEvent | Event,
        reason?: string
    ) => {
        if (reason === "clickaway") {
            return;
        }

        setOpen(false);
        props.onClose();
    };

    return (
        <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
            <Alert
                onClose={handleClose}
                severity={props.isError ? "error" : "success"}
                variant="filled"
                sx={{ width: "100%" }}
            >
                {props.message}
            </Alert>
        </Snackbar>
    );
};
